import { gsap } from 'gsap/all';

class Tab {
	constructor(tab, parentPosition, updateParent) {
		this.DOM = { tab };

		this.parentPosition = parentPosition;
		this.updateParent = updateParent;
		this.position = {
			x: this.DOM.tab.getBoundingClientRect().x,
		};

		/* X relative to parent */
		this.x = this.position.x - this.parentPosition.x;
		this.isInView = this.x < this.parentPosition.width - this.parentPosition.padding;

		this.onInit();
	}
	onInit() {
		this.DOM.tab.addEventListener('click', () => this.onSelect());

		if (!this.isInView) {
			gsap.set(this.DOM.tab, { y: '100%' });
		}
	}
	onSelect() {
		this.updateParent(this.DOM.tab.getBoundingClientRect().x);
	}
	onScroll() {
		this.x = this.DOM.tab.getBoundingClientRect().x - this.parentPosition.x;
		this.isInView = this.x < this.parentPosition.width - this.parentPosition.padding;

		if (this.isInView) {
			this.onInView();
		} else {
			this.onOutView();
		}
	}
	onInView() {
		gsap.to(this.DOM.tab, { y: '0%', duration: 0.2, delay: 0.1, ease: 'expo.out' });
	}
	onOutView() {
		gsap.to(this.DOM.tab, { y: '100%', duration: 0.2, ease: 'expo.out' });
	}
}

class TabScroll {
	constructor(tabContainer) {
		this.DOM = { tabContainer };
		this.DOM.tabs = [...this.DOM.tabContainer.querySelectorAll('.nav-item')];

		this.properties = {
			x: this.DOM.tabContainer.getBoundingClientRect().x,
			width: this.DOM.tabContainer.getBoundingClientRect().width,
			padding: gsap.getProperty(this.DOM.tabContainer, 'paddingLeft') + 4, // add 4px for every items padding right ;
		};

		this.tabs = this.DOM.tabs.map((tab) => new Tab(tab, this.properties, this.onSelect));

		this.onInit();
	}
	onInit() {
		this.DOM.tabContainer.addEventListener('scroll', () => this.onScroll());
	}
	onSelect = (x) => {
		/* Scroll to the current scroll value + the x value of the selected tab - the parent x position - the padding */
		this.DOM.tabContainer.scrollTo({
			left: this.DOM.tabContainer.scrollLeft + x - this.properties.x - this.properties.padding,
			behavior: 'smooth',
		});
	};
	onScroll = () => {
		/* Update x value for every tab */
		this.tabs.forEach((tab) => tab.onScroll());
	};
}

const tabNodes = document.querySelectorAll('.nav-tabs');
[...tabNodes].forEach((node) => new TabScroll(node));
